import React from 'react'
import { I18n } from '@front/volcanion/'

import { Grid, Typography, Box, StepLabel, StepContent } from '@mui/material'

import { SingleOptionSelectorField, MenuSelectorField, ModelAutocompleteField } from '@front/squirtle/'

const Row1 = ({ isCeiling, ...props }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <ModelAutocompleteField
        name={'start_zone'}
        label={I18n.t('address.source')}
        model_name={'zone'}
        labelKeys={['name']}
        searchMode={'search'}
        searchQuery={'contains'}
        autocompleteKey={'name'}
        selectFirst={false}
        loadOnMount
        required
      />
    </Grid>
    <Grid size="grow">
      <ModelAutocompleteField
        name={'end_zone'}
        label={I18n.t('address.destination')}
        model_name={'zone'}
        labelKeys={['name']}
        searchMode={'search'}
        searchQuery={'contains'}
        autocompleteKey={'name'}
        selectFirst={false}
        loadOnMount
        required
      />
    </Grid>
    <Grid hidden={isCeiling} size="grow">
      <MenuSelectorField
        name={'distance_algo'}
        label={I18n.t('distance.algo.label')}
        options={[
          { label: I18n.t('distance.algo.none'), value: null },
          { label: I18n.t('distance.algo.source'), value: 'source' },
          { label: I18n.t('distance.algo.destination'), value: 'destination' },
          { label: I18n.t('distance.algo.full'), value: 'full' }
        ]}
        required
      />
    </Grid>
  </Grid>

const Row2 = ({ isCeiling, ...props }) =>
  <Grid container spacing={1} direction='row' alignItems='center' size={6}>
    <Grid hidden={isCeiling} size="grow">
      <SingleOptionSelectorField
        name={'individual_pricing'}
        optionLabel={I18n.t('pricerule.individual_pricing')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'two_way'}
        optionLabel={I18n.t('transport.two_way')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        name='distance_strategy'
        label={I18n.t('distance.strategy.label')}
        options={[
          { label: I18n.t('distance.strategy.basic'), value: 'basic' },
          { label: I18n.t('distance.strategy.google'), value: 'google' },
        ]}
        required
      />
    </Grid>
  </Grid>

const GeoSection = props => <>
  <StepLabel>
    <Typography variant='h5'> {I18n.t('zone.associated')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ borderRadius: 3, boxShadow: 6, p: 2, mb: 1 }}>
      <Grid container rowSpacing={2}>
        <Row1 {...props} />
        <Row2 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(GeoSection)
